import { Component, OnInit } from '@angular/core';
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-rentals-categories',
  templateUrl: './rentals-categories.component.html',
  styleUrls: ['./rentals-categories.component.scss'],
  providers: [MessageService]
})
export class RentalsCategoriesComponent implements OnInit {

  public selectedTab = 0;

  constructor(
    public messageService: MessageService
  ) { }

  ngOnInit() {
  }

}
